import React from 'react';
import { Link, NavLink } from "react-router-dom";

import './style.css';

import LOGO from './logo/logo.png';

export default function Header() {
   return (
      <header className='header_components'>
         <div className='header _container'>
            <Link onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} to={"/"}><img src={LOGO} alt="Interno" /></Link>
            <ul className='nav_list'>
               <li className='home_link _link'>
                  <NavLink onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} to="/" >
                     Home
                  </NavLink>
               </li>
               <li className='pages_link _link'>
                  <NavLink to="project">
                     Project
                  </NavLink>
               </li>
               <li className='about_link _link'>
                  <NavLink to="about">
                     About
                  </NavLink>
               </li>
               <li className='services_link _link'>
                  <NavLink to="blog">
                     Blog
                  </NavLink>
               </li>
               <li className='contacts_link _link'>
                  <NavLink to="contacts">
                     Contact Us
                  </NavLink>
               </li>
            </ul>
         </div>
      </header>
   )
}